import React from 'react'
import styled from 'styled-components'

const ImageContainer = styled.div<{ top?; left?; zindex?; right?; bottom?; rotate?; position?; width?; height? }>`
  position: ${({ position }) => position || 'absolute'};
  left: ${({ left }) => left || 'auto'};
  right: ${({ right }) => right || 'auto'};
  top: ${({ top }) => top || 'auto'};
  bottom: ${({ bottom }) => bottom || 'auto'};
  z-index: ${({ zindex }) => zindex || 'auto'};
  transform: ${({ rotate }) => rotate || 'rotate(0deg)'};
  width: ${({ width }) => width || 'auto'};
  height: ${({ height }) => height || 'auto'};
`

export default ImageContainer
